import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import type { Color } from '~/types';

const breakpoints = useBreakpoints(breakpointsTailwind)
export const isMobile = breakpoints.smaller('md')

export const getBadgeColor = (status: Color) => {
  const statusColors: Record<string, Color> = {
    // "În completare": "neutral",
    // "În așteptare": "neutral",

    "Completat": "success",
    "Completată": "success",
    "Finalizat": "success",
    "Finalizată": "success",
    "Recomandat": "success",

    "Respins": "error",
    "Respinsă": "error",
    "Refuzat": "error",
    "Refuzată": "error",
  };
  return statusColors[status] ?? ("primary" as Color);
};

export const scrollToTop = () => {
  // Find element that actually has scroll
  const allElements = document.querySelectorAll('*')
  
  for (const el of allElements) {
    if (el.scrollTop > 0) {
      el.scrollTo({ top: 0, behavior: 'smooth' })
      break // Stop after first one
    }
  }
}